import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import 'vuetify/dist/vuetify.min.css'
import AOS from "aos";
import "aos/dist/aos.css";
import newsMessage from "./components/newsMessage.vue"; // 请根据你的实际路径修改
import Banner from "./components/banner.vue"; // 全域組件註冊


Vue.component("newsMessage", newsMessage);
Vue.component("Banner", Banner);// 全域組件註冊


Vue.config.productionTip = false
// Vue.use(VueRouter)
// 初始化 AOS
AOS.init();

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')

// package.json底下的
  // "scripts": {
  //   "serve": "vue-cli-service serve",
  //   "build": "vue-cli-service build"
  // },


